/* eslint-disable no-case-declarations */

import i18n from '@shared/i18n/index';

/**
 * @deprecated
 * [分钟转时间格式]
 * @param  {number} minutesPassed [需要转义的数字，单位是分钟]
 * @return {string}     [返回转义后的时间格式]
 */
export const formatMinutes = (minutesPassed: number): string => {
	switch (true) {
		case minutesPassed <= 15:
			return i18n.get('Date_Justnow_Text');
		case minutesPassed < 60:
			// return `${Math.floor(minutesPassed)} minutes ago`;
			return i18n.get('Date_Minuteago_Text', { x: Math.floor(minutesPassed) });
		case minutesPassed < 24 * 60:
			const hoursPassed = Math.floor(minutesPassed / 60);
			// return `${hoursPassed} hours ago`;
			return i18n.get('Date_Hourago_Text', { x: hoursPassed });
		case minutesPassed < 48 * 60:
			return i18n.get('Date_Yesterday_Text');
		case minutesPassed < 30 * 24 * 60:
			const dayPassed = Math.floor(minutesPassed / 60 / 24);
			// return `${dayPassed} days ago`;
			return i18n.get('Date_Dayago_Text', { x: dayPassed });
		default:
			const exactDate = new Date(Date.now() - minutesPassed * 60 * 1000);
			const year = exactDate.getFullYear();
			const isSameYear = year === new Date().getFullYear();
			const monthNames = [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			];
			const result =
				`${monthNames[exactDate.getMonth()]} ${exactDate.getDate()}` +
				(isSameYear ? '' : `, ${year}`);
			return result;
	}
};

/**
 * [分钟转时间格式]
 * @param  {number} minutesPassed [需要转义的数字，单位是分钟]
 * @return {string}     [返回转义后的时间格式]
 * 1. 如果是今天，返回具体时间，格式 2:35 PM
 * 2. 如果是昨天，返回 Yesterday
 * 3. 如果是今年，返回 MMM D 格式，如 Jan 5
 * 4. 如果不是今年，返回 MMM D, YYYY 格式，如 Jan 5, 2022
 */
export const formatMinutesNew = (minutesPassed: number): string => {
	const now = new Date();
	const pastDate = new Date(Date.now() - minutesPassed * 60 * 1000);

	const isToday = pastDate.toDateString() === now.toDateString();
	const yesterday = new Date();
	yesterday.setDate(now.getDate() - 1);
	const isYesterday = pastDate.toDateString() === yesterday.toDateString();

	if (isToday) {
		// 返回具体时间，格式 2:35 PM
		const hours = pastDate.getHours();
		const minutes = pastDate.getMinutes();
		const period = hours >= 12 ? 'PM' : 'AM';
		const displayHour = hours % 12 === 0 ? 12 : hours % 12;
		const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
		return `${displayHour}:${displayMinutes} ${period}`;
	}

	if (isYesterday) {
		return i18n.get('Date_Yesterday_Text'); // 'Yesterday'
	}

	// 判断是否同一年
	const isSameYear = pastDate.getFullYear() === now.getFullYear();
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];
	const dateStr = `${monthNames[pastDate.getMonth()]} ${pastDate.getDate()}`;
	return isSameYear ? dateStr : `${dateStr}, ${pastDate.getFullYear()}`;
};
